module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg6-68b1cecde01f64d56b7fbbe67f6dbcdd.jpg";